<template>
    <div class="space-tile small-corners">
        <better-link class="link" :to="permalink(tileData)">
            <div class="featured-image" :style="`background-image:url(${tileData.photos.length ? tileData.photos[0].permalink + '?w=800' : '//drench.imgix.net/media/drench-site-no-image.jpg?w=800'});`">
                <HeartCircleButton :site="tileData" @data-changed="$listeners['data-changed']" />
                <div v-if='nudityAvailable(tileData)' class="featured-attribute shadow">{{ nudityAvailable(tileData) | ucWords }}</div>
            </div>
            
            <div class="space-tile-content">
                <StarRating v-if="tileData.average_ratings && Object.keys(tileData.average_ratings).length" :rating="combinedAverageRating(tileData.average_ratings)" class="float-right" />
                <h4>{{ tileData.name }}</h4>
                <address class="mb-1">{{ tileData.location.formatted_locality }}</address>
                <div class="text-muted">{{ tileData.short_description }}</div>
                <ul class="important-attributes list-unstyled d-flex justify-content-between mt-1 mb-0">
                    <li v-if="tileData.min_price > 0">{{ formattedLowestPrice(tileData) }}</li>
                    <li v-if="tileData.number_of_pools > 0">{{ tileData.number_of_pools | withDeclensionalWord(' pool', ' pools') }}</li>
                    <li v-if="tileData.min_temp > 0">{{ temperatureRange(tileData) }}</li>
                    <li v-if="tileData.hours && Object.keys(tileData.hours).length">{{ openInfo }}</li>
                </ul>
            </div>
        </better-link>
    </div>
</template>

<script>
import StarRating from '../elements/StarRating'
import HeartCircleButton from '../elements/HeartCircleButton'
import SiteMixins from '@/mixins/SiteMixins';
import CurrencyMixins from '@/mixins/CurrencyMixins';

export default {
    name: 'SiteTile',
    mixins: [
        SiteMixins,
        CurrencyMixins,
    ],
    components: {
        StarRating,
        HeartCircleButton,
    },
    props: {
        tileData: {
          type: Object,
          required: true,
        },
        route: {
          type: String,
          default() {
            return 'Site'
          },
        },
    },
    methods: {
        permalink(tile) {
            return {name: this.route, params: {id: tile.slug}}
        },
    },
    computed: {
        openInfo() {
            if (this.isOpenNow(this.tileData.hours, this.tileData.location.timezone)) {
                return 'Open Now'
            }
            return 'Closed'
        }
    },
};
</script>

<style lang="scss">
.space-tile {
    margin: 10px 0;
    overflow: hidden;
    box-shadow: 0px 3px 9px 0px rgba(0,0,0,0.15);
    background: white;
    
    .link {
        display: block;
        position: relative;
        color: $almost-black;
        text-decoration: none;
        
        .featured-image {
            position: relative;
            width: 100%;
            height: 0;
            padding-top: 67%;
            background-size: cover;
            background-position: center center;
            overflow: initial;
            
            .heart-circle-button {
                position: absolute;
                right: 15px;
                top: 15px;
                z-index: 10;
            }
            
            .featured-attribute {
                position: absolute;
                bottom: 15px;
                left: 15px;
                padding: 6px 14px;
                background: white;
                border: $light-gray;
                border-radius: 4px;
                text-transform: uppercase;
                font-weight: bold;
                color: $almost-black;
            }
        }
        
        .space-tile-content {
            padding: 0 10px 10px;
            
            h4 {
                margin: 12px 0 0;
                font-size: 18px;
            }
            address {
                margin-bottom: 0;
                font-size: 15px;
            }
            .text-muted {
                font-size: 14px;
            }
        }
    }
}
</style>


